import "./App.css";
import { Header, Footer, Scroll } from "./components";
import { HomePage, ProjectDetailPage } from "./pages";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

const App = () => {
  return (
    <Router>
      <div>
        <Header />
        <main className="main">
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/projects/:title" element={<ProjectDetailPage />} />
          </Routes>
          <Footer />
        </main>
        <Scroll />
      </div>
    </Router>
  );
};

export default App;
